module.exports = __webpack_public_path__ + "static/media/black_belt_icon.2a918ed0.svg";